"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onPresenceChangedHandlerForHost = onPresenceChangedHandlerForHost;
exports.onPresenceChangedHandlerForSpeaker = onPresenceChangedHandlerForSpeaker;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../constants/logger");
var _getAttendeePresenceFunc = require("./getAttendeePresenceFunc");
var _subscribeToVolumeIndicator = require("../subscribeToVolumeIndicator");
var _audioVideoHelpers = require("../../audioVideo/audioVideoHelpers");
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
function onPresenceChangedHandlerForHost(dispatch, actions, meetingSession, meetingResponse) {
  var localAttendeeId = meetingSession.configuration.credentials.attendeeId;
  var meetingId = meetingResponse.Meeting.MeetingId;
  var disconnectSource = actions.disconnectSource,
    setAttendeePresence = actions.setAttendeePresence,
    setAttendeeMuteStatus = actions.setAttendeeMuteStatus,
    setSourceInitializing = actions.setSourceInitializing,
    removePresenter = actions.removePresenter,
    setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;
  return function onPresenceChanged(attendeeId, present, _, dropped) {
    var setPresence = (0, _getAttendeePresenceFunc.getAttendeePresenceFunc)(dispatch, {
      disconnectSource: disconnectSource,
      setAttendeePresence: setAttendeePresence
    }, attendeeId);
    setPresence(attendeeId, present);
    if (present) {
      (0, _subscribeToVolumeIndicator.subscribeToVolumeIndicator)(dispatch, setAttendeeMuteStatus, meetingSession, attendeeId, setAttendeeVoiceIntensity);
      dispatch(setSourceInitializing(attendeeId, {
        isInitializing: false
      }));
    } else {
      if (attendeeId.includes('content')) {
        dispatch(removePresenter(attendeeId));
        if ("".concat(localAttendeeId, "#content") === attendeeId) {
          (0, _audioVideoHelpers.stopContentShare)(meetingSession);
        }
      }
      meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId);
    }
    var logPayload = {
      chimeEventName: 'onPresenceChanged',
      dropped: dropped,
      'studio.meeting.id': meetingId,
      title: "Attendee id: ".concat(attendeeId, " presence changed to ").concat(present, " in meeting id: ").concat(meetingId)
    };
    logger.info(logPayload.title, logPayload);
  };
}
function onPresenceChangedHandlerForSpeaker(dispatch, actions, meetingSession) {
  var localAttendeeId = meetingSession.configuration.credentials.attendeeId;
  var updateAttendeePresence = actions.updateAttendeePresence,
    setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity,
    setAttendeeCameraStatus = actions.setAttendeeCameraStatus;
  return function onPresenceChanged(attendeeId, present) {
    // We don't want to set the camera status to false for the local attendee on entry/exit
    // Because the camera status for the local attendee is determined by the number of attendees
    // in the meeting and their camera status, not just their presence
    var isNotLocalAttendee = attendeeId !== localAttendeeId;
    if (present && !!setAttendeeCameraStatus && !attendeeId.includes('#content') && isNotLocalAttendee) {
      dispatch(setAttendeeCameraStatus(attendeeId, false));
    }
    if (!!setAttendeeVoiceIntensity) {
      if (present) {
        (0, _subscribeToVolumeIndicator.subscribeToVolumeIndicator)(dispatch, null, meetingSession, attendeeId, setAttendeeVoiceIntensity);
      } else {
        meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId);
      }
    }
    if (!present && "".concat(localAttendeeId, "#content") === attendeeId) {
      (0, _audioVideoHelpers.stopContentShare)(meetingSession);
    }
    dispatch(updateAttendeePresence(attendeeId, present));
    var logPayload = {
      chimeEventName: 'onPresenceChanged',
      title: "Attendee id: ".concat(attendeeId, " presence changed to ").concat(present)
    };
    logger.info(logPayload.title, logPayload);
  };
}